import "./wizard.less";

import {t} from "@lingui/core/macro";
import {Trans} from "@lingui/react/macro";
import * as React from "react";

import {useOnMountEffect} from "@khanacademy/wonder-blocks-core";
import Link from "@khanacademy/wonder-blocks-link";
import {usePublishAnalyticsEvent} from "@khan/analytics-learning-time";

type Props = {
    kaLocale: string;
    countryCode: string;
};

export default function EnglishOnly(props: Props): React.ReactElement {
    const publishAnalyticsEvent = usePublishAnalyticsEvent();
    const {kaLocale, countryCode} = props;
    useOnMountEffect(() => {
        publishAnalyticsEvent({
            eventType: "KhanLabsEnglishOnlyPageViewed",
            eventSchemaVersion: 2,
            kaLocale: kaLocale,
            countryCode: countryCode,
        });
    });

    return (
        <div className="wizard-view">
            <div className="container">
                <h1 className="sad-path-heading">
                    {t`Hi! Thank you for your interest in Khanmigo.`}
                </h1>
                <p>
                    {
                        <Trans>
                            Khanmigo does not yet fully support your selected
                            language. If you’d like to learn more about
                            Khanmigo,{" "}
                            <Link href="https://khanmigo.ai" inline={true}>
                                please visit this page
                            </Link>
                            .
                        </Trans>
                    }
                </p>
                <p>
                    {t`Thank you for your interest and sorry for the inconvenience.`}
                </p>
            </div>
        </div>
    );
}
